var Compare = {
    callbacks: {
        addedItem: function(form, response) {
            Eshop.alert(response.message);
            // update quantity
            $('[data-element="compare"]')
                .filter('[data-type="quantity"]')
                .html(response.count)
                .attr('data-value', response.count);
            Compare.customCallbacks.addedItem(form, response);
        },
        toggledItem: function(form, response) {
            Eshop.alert(response.message);
            // update quantity
            $('[data-element="compare"]')
                .filter('[data-type="quantity"]')
                .html(response.count)
                .attr('data-value', response.count);
            Compare.customCallbacks.toggledItem(form, response);
        }
    },
    customCallbacks: {
        addedItem: function(form, response) {}
    },
    addItem: function(form) {
        Form.ajaxPost(form, function(response) {
            Compare.callbacks.addedItem(form, response);
        }, 'json');

        return false;
    },
    toggleItem: function(form) {
        Form.ajaxPost(form, function(response) {
            Compare.callbacks.toggledItem(form, response);
        }, 'json');

        return false;
    },
};

$(function() {
    $('body').delegate('[data-ec-action="addProductToCompare"][type="checkbox"]', 'change', function() {
        var $this = $(this),
            $form = $this.parents('form');

        $form.attr('action', $form.data('add'));
        if (!$this.is(':checked')) {
            $form.attr('action', $form.data('remove'));
        }
        $form.submit();
    });
});